(function(){
    function initViewport(viewport){
      const track = viewport.querySelector('[data-carousel-track]');
      if(!track) return;
  
      const direction = (viewport.dataset.direction || 'left') === 'right' ? 1 : -1;
      const speedPxPerSec = parseInt(viewport.dataset.speed || '60', 10);
  
      let rafId; let lastTs; let offset = 0;
      let loopDistance = 0; 
      let isInitialized = false; 
  
      function updatePadding(){
        if(direction < 0){
          track.style.paddingLeft = '24px';
          track.style.paddingRight = '0px';
        } else {
          track.style.paddingLeft = '24px';
          track.style.paddingRight = '0px';
        }
      }
      function computeLoopDistance(){
        const groups = track.querySelectorAll('.mt-logo-list__group');
        const firstGroup = groups[0];
        
        if(!firstGroup) {
          loopDistance = Math.floor(track.scrollWidth / 2);
          console.log('No groups found, using half of scrollWidth:', loopDistance);
          return loopDistance;
        }
        
        const style = getComputedStyle(track);
        const gap = parseInt(style.gap || '0', 10);
        const items = firstGroup.querySelectorAll('.mt-logo-list__item');
        
        let width = 0;
        items.forEach((item, idx) => {
          width += item.offsetWidth;
          if(idx < items.length - 1) width += gap;
        });
        
        loopDistance = width + gap;

        if(!isInitialized && direction > 0) {
          offset = -loopDistance;
          isInitialized = true;
        }
        
        return loopDistance;
      }
  
      function startLoop(){
        if(rafId) return;
        lastTs = undefined;
        rafId = requestAnimationFrame(loop);
      }
  
      function loop(ts){
        if(!lastTs) lastTs = ts;
        const dt = (ts - lastTs) / 1000;
        lastTs = ts;
        offset += direction * speedPxPerSec * dt;

        if(loopDistance === 0) computeLoopDistance();
        
        // Debug: log offset periodically
        if(Math.random() < 0.01) {
          console.log('Current offset:', offset.toFixed(2), 'Direction:', direction > 0 ? 'RIGHT' : 'LEFT', 'LoopDistance:', loopDistance);
        }

        if(loopDistance > 0){
          // 无缝循环：当到达边界时，平滑地重置位置
          if(direction < 0){
            // 向左滚动：从0减少到-loopDistance，当offset超过-loopDistance时重置到0
            if(offset <= -loopDistance) {
              console.log('Left: Resetting offset from', offset.toFixed(2), 'to 0');
              offset = 0;
            }
          } else {
            // 向右滚动：从-loopDistance增加到0，当offset达到或超过0时重置到-loopDistance
            if(offset >= 0) {
              console.log('Right: Resetting offset from', offset.toFixed(2), 'to -', loopDistance, '(loopDistance:', loopDistance + ')');
              offset = -loopDistance;
            }
          }
        }

        const x = Math.round(offset);
        track.style.transform = `translate3d(${x}px,0,0)`;
        rafId = requestAnimationFrame(loop);
      }
  
      // Drag state
      let isDragging = false;
      let startX = 0;
      let dragStartOffset = 0;
  
      function onDragStart(e){
        isDragging = true;
        startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
        dragStartOffset = offset;
        cancelAnimationFrame(rafId);
        rafId = null;
      }
  
      function onDragMove(e){
        if(!isDragging) return;
        e.preventDefault();
        
        const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
        const diff = currentX - startX;
        offset = dragStartOffset + diff;
        
        const dragDirection = diff > 0 ? -1 : 1;
        if(dragDirection < 0){
          track.style.paddingLeft = '24px';
          track.style.paddingRight = '0px';
        } else {
          track.style.paddingLeft = '0px';
          track.style.paddingRight = '24px';
        }
  
        if(loopDistance > 0){
          if(direction < 0 && offset <= -loopDistance) {
            offset = 0;
          } else if(direction > 0 && offset >= 0) {
            offset = -loopDistance;
          }
        }
  
        const x = Math.round(offset);
        track.style.transform = `translate3d(${x}px,0,0)`;
      }
  
      function onDragEnd(){
        if(!isDragging) return;
        isDragging = false;
        // Resume auto-scroll
        if(!rafId){
          lastTs = null;
          startLoop();
        }
      }
  
      viewport.addEventListener('mousedown', onDragStart);
      viewport.addEventListener('mousemove', onDragMove);
      viewport.addEventListener('mouseup', onDragEnd);
      viewport.addEventListener('mouseleave', onDragEnd);
      viewport.addEventListener('touchstart', onDragStart, {passive: false});
      viewport.addEventListener('touchmove', onDragMove, {passive: false});
      viewport.addEventListener('touchend', onDragEnd);
  
      const imgs = Array.from(track.querySelectorAll('img'));
      let pending = imgs.length;
      if(pending === 0){
        updatePadding();
        computeLoopDistance();
        startLoop();
      } else {
        imgs.forEach(img => {
          if(img.complete && img.naturalWidth > 0){
            if(--pending === 0){ updatePadding(); computeLoopDistance(); startLoop(); }
          } else {
            img.addEventListener('load', function(){ if(--pending === 0){ updatePadding(); computeLoopDistance(); startLoop(); } }, { once: true });
            img.addEventListener('error', function(){ if(--pending === 0){ updatePadding(); computeLoopDistance(); startLoop(); } }, { once: true });
          }
        });
      }
    }
  
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('.mt-logo-list [data-carousel-viewport]').forEach(initViewport);
    });
  })();
  